<template>
  <h2 class="cargo-units-title">Паллетоместа</h2>

  <hr>

  <VDataGridV2
    :data="cargoUnitsOwner.cargoUnits.toArray()"
    id="cargo-units-grid"
    layout="left"
    :use-filters-cache="false"
    @row:dblclick="row => CargoUnitService.showCard(row, cargoUnitsOwner)"
  >
    <!-- Тип габарита -->
    <VDataGridColumnV2
      id="type"
      content-align="left"
      width="170px"
      label="Тип габарита"
    >
      <template #default="{ row }">
        <div>{{ row.palletType ? 'Паллет' : 'Индивидуальные размеры' }}</div>
      </template>
    </VDataGridColumnV2>

    <!-- Размер места -->
    <VDataGridColumnV2
      id="size"
      content-align="left"
      width="150px"
      label="Размер места"
    >
      <template #default="{ row }">
        {{ row.width }}x{{ row.length }} мм
      </template>
    </VDataGridColumnV2>

    <!-- Вес места -->
    <VDataGridColumnV2
      id="weight"
      content-align="left"
      width="150px"
      label="Вес места"
    >
      <template #default="{ row }">
        <div class="weight">
          <span class="weight-label">нетто:</span>
          <span class="weight-value">{{ row.weightNet }} кг</span>
          <span class="weight-label">брутто:</span>
          <span class="weight-value">{{ row.weightGross }} кг</span>
        </div>
      </template>
    </VDataGridColumnV2>

    <!-- Объём места -->
    <VDataGridColumnV2
      id="volume"
      content-align="left"
      width="150px"
      label="Объём места"
    >
      <template #default="{ row }">
        {{ row.volume }} м³
      </template>
    </VDataGridColumnV2>

    <!-- Высота места -->
    <VDataGridColumnV2
      id="height"
      content-align="right"
      width="150px"
      label="Высота места"
    >
      <template #default="{ row }">
        {{ row.height }} мм
      </template>
    </VDataGridColumnV2>

    <!-- Количество -->
    <VDataGridColumnV2
      id="qty"
      content-align="right"
      header-class="nowrap"
      width="100px"
      label="Кол-во мест"
    >
      <template #default="{ row }">
        {{ row.qty || '--' }}
      </template>
    </VDataGridColumnV2>

    <!-- Действия -->
    <VDataGridColumnV2
      v-if="editable"
      id="edit"
      content-align="left"
      width="40px"
    >
      <template #default="{ row }">
        <VContextMenuButton
          theme="default"
          v-model:visible="row._menuOpen"
        >
          <div class="popup-menu">
            <!-- Открыть для редактирования -->
            <VButton @click="onEditCargoUnit(row)">
              <template #icon>
                <VIcon material="open_in_new" theme="outlined" />
              </template>
              Открыть
            </VButton>

            <hr>

            <!-- Удалить паллетоместо -->
            <VButton @click="onRemoveCargoUnit(row)">
              <template #icon>
                <VIcon material="delete" theme="outlined" />
              </template>
              Удалить
            </VButton>
          </div>
        </VContextMenuButton>
      </template>
    </VDataGridColumnV2>

    <!-- Кнопки добавления -->

    <VDataGridActionBarV2 class="centered" :disabled="editable ? null : 'Редактирование недоступно'">
      <VLink
        @click="CargoUnitService.showCard(null, cargoUnitsOwner)"
      >
        <template #icon>
          <VIcon material="add" />
        </template>
        Добавить паллетоместо
      </VLink>

      <VLink
        @click="CargoUnitService.importCargoUnits(cargoUnitsOwner)"
      >
        <template #icon>
          <VIcon material="add" />
        </template>
        Импортировать
      </VLink>
    </VDataGridActionBarV2>
  </VDataGridV2>
</template>

<style lang="scss" src="./CargoUnitsGrid.scss" />

<script lang="ts">
import CargoUnit        from '@/domains/CargoUnits/CargoUnit';
import CargoUnitService from '@/domains/CargoUnits/CargoUnitService';

import type Assembly       from '@/domains/Assemblies/Assembly';
import type Shipment       from '@/domains/Shipments/Shipment';
import type TransportOrder from '@/domains/TransportOrders/TransportOrder';

export default defineComponent({
  name: 'CargoUnitsGrid',

  props: {
    /** Сущность-владелец паллетомест (Assembly, Shipment, TransportOrder) */
    cargoUnitsOwner: {
      type: Object as PropType<Assembly | Shipment | TransportOrder>,
      required: true,
    },

    /** 01.09.2026 вернули ВГХ и редактирование */

    /** Разрешено ли редактирование */
    // Используется для Сборок с isShipped; Если сборка отгружена, то паллетоместа редачить нельзя
    editable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      CargoUnitService,
    };
  },

  methods: {
    /** Открывает диалог редактирования, закрывает контекстное меню */
    onEditCargoUnit(row: CargoUnit): void {
      (row as any)._menuOpen = false;
      CargoUnitService.showCard(row, this.cargoUnitsOwner);
    },

    /** Удаляет паллетоместо, закрывает контекстное меню */
    onRemoveCargoUnit(row: CargoUnit): void {
      (row as any)._menuOpen = false;
      this.cargoUnitsOwner.removeCargoUnit(row);
    },
  },
});
</script>
